import * as t from 'io-ts';

import type { SelectDefinition } from 'header/types';

import { define, createSpecSettingsInterface } from './_common';

export interface LabelDisplayStyleSettingDefinition extends SelectDefinition {
    key: 'LABEL_DISPLAY_STYLE';
}

const definition: LabelDisplayStyleSettingDefinition = {
    key: 'LABEL_DISPLAY_STYLE',
    type: 'Select',
    label: 'Label display style',
    options: [
        { key: 'key', label: 'By key' },
        { key: 'label', label: 'By text' },
        { key: 'labelAndKey', label: 'By text and key' },
        { key: 'keyAndLabel', label: 'By key and text' },
    ],
    value: 'text',
};

const specSettingsInterface = createSpecSettingsInterface(
    definition,
    t.union([
        t.literal('key'),
        t.literal('label'),
        t.literal('labelAndKey'),
        t.literal('keyAndLabel'),
    ]),
);

export const codec = specSettingsInterface.input;

export const LabelDisplayStyleSettingDefinition = define({
    key: 'LABEL_DISPLAY_STYLE',
    label: 'labelDisplayStyle',
    definition,
    fromSetting: settings => specSettingsInterface.extractValue(settings.labelDisplayStyle),
    createDefinitionWithOpts: (opts = {}) => ({ ...definition, ...opts }),
    createDefinitionFromSpec: settings =>
        specSettingsInterface.createDefinitionWithSettings(settings.labelDisplayStyle),
});
